/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Back_To_OverviewInputs */



/**
* | output |
* | --- |
* | "Back to datasets" |
*
* @param {Datasets_Back_To_OverviewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_back_to_overview = /** @type {((inputs?: Datasets_Back_To_OverviewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Back_To_OverviewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurück zu den Datensätzen")
	return /** @type {LocalizedString} */ ("Back to datasets")
});